export function buttonReducerErrorMessage(e: unknown): string {
	let message = "";
	if (e === null || e === undefined) {
		message = "An error occurred";
	} else if (typeof e === "string") {
		message = e;
	} else if (typeof e === "object" && "message" in e) {
		message = String(e.message);
	} else if (typeof e?.toString === "function") {
		message = e.toString();
	} else {
		message = "An error occurred";
	}

	return message;
}
